var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiamond = function SvgIconDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.9 4.634c.227-.275.565-.435.922-.435H18.27c.357 0 .695.16.923.435l3.332 4.478a1.2 1.2 0 0 1-.055 1.593l-9.56 9.922a1.2 1.2 0 0 1-.867.372c-.316 0-.631-.124-.867-.372L1.53 10.705a1.2 1.2 0 0 1-.056-1.592zM6.103 6 4.2 9h3.9l.857-3zm4.716 0L9.9 9h4.2l-.9-3zm4.316 0 .763 3h3.9l-1.812-3zm4.663 4.8h-3.9l-2.1 6.6zM12 17.4l2.1-6.6H9.9zm-3.9-6.6 2.1 6.6-6-6.6z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDiamond;